import { render } from "./DeleteInformationPartView.vue?vue&type=template&id=104ab604"
import script from "./DeleteInformationPartView.vue?vue&type=script&lang=js"
export * from "./DeleteInformationPartView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__